import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/common/alert.service';
import { LoginService } from '../login/login.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  hide = true; 

  queryString = Object();
  submitted = false;
  resetForm: FormGroup;
  passwordVisible = false;
  confirmPasswordVisible = false;


 
  get f() {
    return this.resetForm.controls;
  }

  constructor(
    private loginService: LoginService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.queryString = this.activatedRoute.snapshot.queryParams;
    this.buildForm();

    if (this.queryString?.token) {
      const token = this.queryString?.token;
      const userId = window.atob(token);
      this.f.userId.setValue(userId);
    } else {
      this.alertService.showError('Invalid link');
      this.router.navigate(['login']);
    }
  }

 
  

  buildForm(): void {
    this.resetForm = this.formBuilder.group(
      {
        userId: ['', [Validators.required]],
        password: ['', [Validators.required,  Validators.pattern(/^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d)[A-Za-z\d!@#$%^&*(),.?":{}|<>]{6,}$/)]],
        confirmPassword: ['', [Validators.required]],
      },
      {
        validators: this.passwordMatch.bind(this), 
      }
    );
  }
  
passwordMatch(formGroup: FormGroup) {
  const password = formGroup.get('password');
  const confirmPassword = formGroup.get('confirmPassword');

  if (confirmPassword?.errors && !confirmPassword.errors['mustMatch']) {
    return;
  }

  if (password?.value !== confirmPassword?.value) {
    confirmPassword?.setErrors({ mustMatch: true });
  } else {
    confirmPassword?.setErrors(null);
  }
}


public onSubmit() {
  this.submitted = true;
  if (this.resetForm.invalid) {
    return;
  }

  const data: any = {
    userId: this.f.userId.value,
    password: this.f.password.value,
  };

  this.loginService.resetPassword(data).subscribe(
    (res: any) => {
      if (res.success) {
         this.router.navigate(['/login']);
      } else {
        this.alertService.showError('Email Id does not exist.');
      }
    },
    (error: HttpErrorResponse) => {
      if (error.status === 404) {
        this.alertService.showError('Email Id does not exist.');
      } else {
        this.alertService.showError('Failed to reset password.');
      }
    }
  );
}


  onClickBack() {
    this.router.navigate(['/login']);
  }

  togglePasswordVisibility() {
    this.hide = !this.hide;
  }

  toggleConfirmPasswordVisibility() {
    this.confirmPasswordVisible = !this.confirmPasswordVisible;
  }
}
